import { TableCell, TableRow } from "@mui/material";
import React from "react";
import styled from "@emotion/styled";

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '& .MuiTableCell-root': {
        borderBottom: "none",
        paddingTop: theme.spacing(1.5),
        paddingBottom: theme.spacing(1.5),
    },

    // '&:nth-of-type(odd)': {
    //     backgroundColor: theme.palette.action.hover,
    // },

    // '&:hover': {
    //     backgroundColor: theme.palette.action.hover,
    // }
}));

const ProductSaleItem = ({ item, columns, key }) => {

    return (
        <StyledTableRow key={key + "_cell"}>
            {
                columns.map((column, index) => (
                    // <ProductSaleItem item={product} key={index}/>
                    <TableCell key={index} sx={{ maxWidth: 150, wordBreak: "break-all", }}>{item[column]}</TableCell>
                ))
            }
            {/* <TableCell sx={{pl: theme => theme.spacing(3)}}>
                {item.name}
            </TableCell>
            <TableCell align="right">{item.sales_data.sold_qty}</TableCell>
            <TableCell align="right" sx={{pr: theme => theme.spacing(3)}}>${item.sales_data.income}</TableCell> */}
        </StyledTableRow>

    );
};
/* Todo item prop define */
export default ProductSaleItem;
